<template>
    <div id="SelectBox">
        <div class="record" v-for="(record, key, index) of selectData" :key="index">
            <div>{{key}} :</div>
            <div
                v-for="(item, index) of record"
                :key="index" @click="getClick(item, key)"
                :class="item.focus ? 'focus' : null">
                {{item.dictLabel}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SelectBox',
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                selectData: {}
            }
        },
        methods: {
            getData () {
                console.log(this)
                for (let key in this.data) {
                    this.data[key].map(item => {
                        this.$set(item, 'focus', false)
                    })
                }
                this.selectData = this.data
                console.log(this.selectData)
            },
            getClick (item, key) {
                console.log({[key]: item})
                this.selectData[key].map(item => {
                    this.$set(item, 'focus', false)
                })
                this.$set(item, 'focus', true)
                // item.focus = true
                this.$emit('getClick', item, key)
                // this.$forceUpdate()
            }
        },
        created () {
            this.getData()
        }
    }
</script>

<style scoped lang="less">
    #SelectBox {
        width: 1200px;
        /*height:96px;*/
        background: rgba(248, 248, 248, 1);
        padding: 20px;

        .record {
            margin: 20px auto;
            display: flex;
            justify-content: flex-start;

            div {
                color: rgba(102, 102, 102, 1);
                margin-right: 25px;
                padding: 4px 6px;
                cursor: pointer;

                &:nth-of-type(1) {
                    color: black;
                    font-weight: 600;
                }
            }

            .focus {
                background: rgba(5, 160, 130, 1);
                color: white;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/select-box/SelectBox.vue